import { Request } from '@/classes/Request.ts'

export interface EnrollmentCreateAccountResponse {
  success: boolean
  data?: {
    action?: string
    cloud_token?: string
    family_user?: {
      family_user_id?: number
      first_name?: string
      last_name?: string
      email?: string
    }
    terms_current?: boolean
    current_terms_id?: number | null
  }
  account_exists?: boolean
  failure_reason?: string
  validation_messages?: Record<string, string[]>
}

/**
 * Create the family-user account for a new invitee after email verification
 * (SOW-46/141). Identity comes from the invitation; the invitee supplies a
 * password (when required) + explicit ToS consent. Returns a cloud_token.
 * POST /api/enrollment/invitation/{token}/create-account
 */
export const enrollmentCreateAccount = async (
  token: string,
  payload: { password?: string; terms_accepted: boolean }
): Promise<EnrollmentCreateAccountResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/create-account`,
    payload
  )
  return response.data
}
